/* tslint:disable */
/* eslint-disable */
/**
 * FMS Run API
 * The FMS Run API description
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


// May contain unused imports in some cases
// @ts-ignore
import type { GetDeliveryResponseDtoParticipationEntitlementsInner } from './get-delivery-response-dto-participation-entitlements-inner';

/**
 * 
 * @export
 * @interface UpdateDeliveryOriginResponseDto
 */
export interface UpdateDeliveryOriginResponseDto {
    /**
     * Delivery ID
     * @type {string}
     * @memberof UpdateDeliveryOriginResponseDto
     */
    'id': string;
    /**
     * Creation date in UTC
     * @type {string}
     * @memberof UpdateDeliveryOriginResponseDto
     */
    'createdAt': string;
    /**
     * Last update date in UTC
     * @type {string}
     * @memberof UpdateDeliveryOriginResponseDto
     */
    'updatedAt': string;
    /**
     * Last update date in UTC
     * @type {string}
     * @memberof UpdateDeliveryOriginResponseDto
     */
    'deletedAt': string;
    /**
     * Participation ID this delivery belongs to
     * @type {string}
     * @memberof UpdateDeliveryOriginResponseDto
     */
    'participationId': string;
    /**
     * Event/Challenge title associated with this delivery
     * @type {string}
     * @memberof UpdateDeliveryOriginResponseDto
     */
    'eventName'?: string;
    /**
     * Delivery recipient name
     * @type {string}
     * @memberof UpdateDeliveryOriginResponseDto
     */
    'destinationName': string;
    /**
     * Delivery contact number
     * @type {string}
     * @memberof UpdateDeliveryOriginResponseDto
     */
    'destinationContactNumber': string;
    /**
     * Destination country
     * @type {string}
     * @memberof UpdateDeliveryOriginResponseDto
     */
    'destinationCountry': string;
    /**
     * Destination country code
     * @type {string}
     * @memberof UpdateDeliveryOriginResponseDto
     */
    'destinationCountryCode': string;
    /**
     * Destination province
     * @type {string}
     * @memberof UpdateDeliveryOriginResponseDto
     */
    'destinationProvince': string;
    /**
     * Destination province code
     * @type {string}
     * @memberof UpdateDeliveryOriginResponseDto
     */
    'destinationProvinceCode': string;
    /**
     * Destination city
     * @type {string}
     * @memberof UpdateDeliveryOriginResponseDto
     */
    'destinationCity': string;
    /**
     * Destination city code
     * @type {string}
     * @memberof UpdateDeliveryOriginResponseDto
     */
    'destinationCityCode': string;
    /**
     * Destination barangay
     * @type {string}
     * @memberof UpdateDeliveryOriginResponseDto
     */
    'destinationBarangay': string;
    /**
     * Destination barangay code
     * @type {string}
     * @memberof UpdateDeliveryOriginResponseDto
     */
    'destinationBarangayCode': string;
    /**
     * Destination street address
     * @type {string}
     * @memberof UpdateDeliveryOriginResponseDto
     */
    'destinationStreet': string;
    /**
     * Additional destination address line (apartment, unit, floor, building)
     * @type {string}
     * @memberof UpdateDeliveryOriginResponseDto
     */
    'destinationAddressLine2'?: string;
    /**
     * Destination postal code
     * @type {string}
     * @memberof UpdateDeliveryOriginResponseDto
     */
    'destinationPostalCode': string;
    /**
     * Source API used for destination address data
     * @type {string}
     * @memberof UpdateDeliveryOriginResponseDto
     */
    'destinationSourceApi': UpdateDeliveryOriginResponseDtoDestinationSourceApiEnum;
    /**
     * Origin name
     * @type {string}
     * @memberof UpdateDeliveryOriginResponseDto
     */
    'originName'?: string;
    /**
     * Origin contact number
     * @type {string}
     * @memberof UpdateDeliveryOriginResponseDto
     */
    'originContactNumber'?: string;
    /**
     * Origin country
     * @type {string}
     * @memberof UpdateDeliveryOriginResponseDto
     */
    'originCountry'?: string;
    /**
     * Origin country code
     * @type {string}
     * @memberof UpdateDeliveryOriginResponseDto
     */
    'originCountryCode'?: string;
    /**
     * Origin province
     * @type {string}
     * @memberof UpdateDeliveryOriginResponseDto
     */
    'originProvince'?: string;
    /**
     * Origin province code
     * @type {string}
     * @memberof UpdateDeliveryOriginResponseDto
     */
    'originProvinceCode'?: string;
    /**
     * Origin city
     * @type {string}
     * @memberof UpdateDeliveryOriginResponseDto
     */
    'originCity'?: string;
    /**
     * Origin city code
     * @type {string}
     * @memberof UpdateDeliveryOriginResponseDto
     */
    'originCityCode'?: string;
    /**
     * Origin barangay
     * @type {string}
     * @memberof UpdateDeliveryOriginResponseDto
     */
    'originBarangay'?: string;
    /**
     * Origin barangay code
     * @type {string}
     * @memberof UpdateDeliveryOriginResponseDto
     */
    'originBarangayCode'?: string;
    /**
     * Origin street address
     * @type {string}
     * @memberof UpdateDeliveryOriginResponseDto
     */
    'originStreet'?: string;
    /**
     * Origin postal code
     * @type {string}
     * @memberof UpdateDeliveryOriginResponseDto
     */
    'originPostalCode'?: string;
    /**
     * Source API used for origin address data
     * @type {string}
     * @memberof UpdateDeliveryOriginResponseDto
     */
    'originSourceApi'?: UpdateDeliveryOriginResponseDtoOriginSourceApiEnum;
    /**
     * Current delivery status
     * @type {string}
     * @memberof UpdateDeliveryOriginResponseDto
     */
    'status': UpdateDeliveryOriginResponseDtoStatusEnum;
    /**
     * Tracking number provided by courier
     * @type {string}
     * @memberof UpdateDeliveryOriginResponseDto
     */
    'trackingNo'?: string;
    /**
     * Tracking link URL
     * @type {string}
     * @memberof UpdateDeliveryOriginResponseDto
     */
    'trackingLink'?: string;
    /**
     * Delivery courier/service name
     * @type {string}
     * @memberof UpdateDeliveryOriginResponseDto
     */
    'deliveryCourier'?: string;
    /**
     * Timestamp when delivery was set to on standby
     * @type {string}
     * @memberof UpdateDeliveryOriginResponseDto
     */
    'onStandbyAt'?: string;
    /**
     * Timestamp when delivery status changed to shipping soon
     * @type {string}
     * @memberof UpdateDeliveryOriginResponseDto
     */
    'shippingSoonAt'?: string;
    /**
     * Timestamp when delivery went in transit
     * @type {string}
     * @memberof UpdateDeliveryOriginResponseDto
     */
    'inTransitAt'?: string;
    /**
     * Timestamp when delivery went out for delivery
     * @type {string}
     * @memberof UpdateDeliveryOriginResponseDto
     */
    'outForDeliveryAt'?: string;
    /**
     * Timestamp when delivery was completed
     * @type {string}
     * @memberof UpdateDeliveryOriginResponseDto
     */
    'deliveredAt'?: string;
    /**
     * Timestamp when delivery was cancelled
     * @type {string}
     * @memberof UpdateDeliveryOriginResponseDto
     */
    'cancelledAt'?: string;
    /**
     * Array of image URLs for delivery proof
     * @type {Array<string>}
     * @memberof UpdateDeliveryOriginResponseDto
     */
    'imageUrls': Array<string>;
    /**
     * Whether the delivery has been confirmed by the user
     * @type {boolean}
     * @memberof UpdateDeliveryOriginResponseDto
     */
    'isConfirmedByUser': boolean;
    /**
     * Whether finisher shirt is included in this delivery
     * @type {boolean}
     * @memberof UpdateDeliveryOriginResponseDto
     */
    'shouldIncludeFinisherShirt'?: boolean;
    /**
     * Finisher shirt size if included
     * @type {string}
     * @memberof UpdateDeliveryOriginResponseDto
     */
    'finisherShirtSize'?: string;
    /**
     * Whether medal is included in this delivery
     * @type {boolean}
     * @memberof UpdateDeliveryOriginResponseDto
     */
    'shouldIncludeMedal'?: boolean;
    /**
     * List of entitlements included in this delivery
     * @type {Array<GetDeliveryResponseDtoParticipationEntitlementsInner>}
     * @memberof UpdateDeliveryOriginResponseDto
     */
    'participationEntitlements'?: Array<GetDeliveryResponseDtoParticipationEntitlementsInner>;
    /**
     * Destination recipient name (who will receive the package)
     * @type {string}
     * @memberof UpdateDeliveryOriginResponseDto
     */
    'destinationRecipient'?: string;
    /**
     * Destination contact number
     * @type {string}
     * @memberof UpdateDeliveryOriginResponseDto
     */
    'destinationContact'?: string;
    /**
     * Complete destination address (street, address line 2, barangay, city, province, postal code, country)
     * @type {string}
     * @memberof UpdateDeliveryOriginResponseDto
     */
    'destinationAddress'?: string;
    /**
     * User nickname from participation
     * @type {string}
     * @memberof UpdateDeliveryOriginResponseDto
     */
    'userNickname'?: string;
    /**
     * User full name from participation
     * @type {string}
     * @memberof UpdateDeliveryOriginResponseDto
     */
    'userFullName'?: string;
}

export const UpdateDeliveryOriginResponseDtoDestinationSourceApiEnum = {
    SymphApi: 'symph-api',
    PsgcGitlab: 'psgc-gitlab',
    PsgcCloud: 'psgc-cloud'
} as const;

export type UpdateDeliveryOriginResponseDtoDestinationSourceApiEnum = typeof UpdateDeliveryOriginResponseDtoDestinationSourceApiEnum[keyof typeof UpdateDeliveryOriginResponseDtoDestinationSourceApiEnum];
export const UpdateDeliveryOriginResponseDtoOriginSourceApiEnum = {
    SymphApi: 'symph-api',
    PsgcGitlab: 'psgc-gitlab',
    PsgcCloud: 'psgc-cloud'
} as const;

export type UpdateDeliveryOriginResponseDtoOriginSourceApiEnum = typeof UpdateDeliveryOriginResponseDtoOriginSourceApiEnum[keyof typeof UpdateDeliveryOriginResponseDtoOriginSourceApiEnum];
export const UpdateDeliveryOriginResponseDtoStatusEnum = {
    OnStandby: 'on_standby',
    ShippingSoon: 'shipping_soon',
    InTransit: 'in_transit',
    OutForDelivery: 'out_for_delivery',
    Delivered: 'delivered',
    Cancelled: 'cancelled'
} as const;

export type UpdateDeliveryOriginResponseDtoStatusEnum = typeof UpdateDeliveryOriginResponseDtoStatusEnum[keyof typeof UpdateDeliveryOriginResponseDtoStatusEnum];


